import React from 'react';

import { Logo as BrandLogo } from 'components/logo';

import { CartErrorHeading, Heading } from './styled';

interface ICartHeading {
  modalHeading?: string;
}

const HeadingContainer = ({ modalHeading }: ICartHeading = {}) => (
  <Heading alignItems="center">
    <BrandLogo />
    <CartErrorHeading>{modalHeading}</CartErrorHeading>
  </Heading>
);

export default HeadingContainer;
